var $d10d6b60dc50b438$exports = {};
$d10d6b60dc50b438$exports = {
  "alpha": "Alfa",
  "black": "melns",
  "blue": "Zila",
  "blue purple": "zili violets",
  "brightness": "Spilgtums",
  "brown": "br\u016Bns",
  "brown yellow": "br\u016Bni dzeltens",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "ci\u0101ns",
  "cyan blue": "ci\u0101na zils",
  "dark": "tum\u0161s",
  "gray": "pel\u0113ks",
  "grayish": "pel\u0113c\u012Bgs",
  "green": "Za\u013Ca",
  "green cyan": "za\u013C\u0161 ci\u0101ns",
  "hue": "Nokr\u0101sa",
  "light": "gai\u0161s",
  "lightness": "Gai\u0161ums",
  "magenta": "fuksiju",
  "magenta pink": "fuksiju roz\u0101",
  "orange": "oran\u017Es",
  "orange yellow": "oran\u017Ei dzeltens",
  "pale": "b\u0101ls",
  "pink": "roz\u0101",
  "pink red": "roz\u012Bgi sarkans",
  "purple": "violets",
  "purple magenta": "violets fuksiju",
  "red": "Sarkana",
  "red orange": "sarkan\u012Bgi oran\u017Es",
  "saturation": "Pies\u0101tin\u0101jums",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " caursp\u012Bd\u012Bgs");
  },
  "very dark": "\u013Coti tum\u0161s",
  "very light": "\u013Coti gai\u0161s",
  "vibrant": "ko\u0161s",
  "white": "balts",
  "yellow": "dzeltens",
  "yellow green": "dzelteni za\u013C\u0161"
};
export { $d10d6b60dc50b438$exports as default };